import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import React from 'react'

import {
  type ProfileAndSettingsState,
  useProfileAndSettingsState,
} from './useProfileAndSettingsState'

export const ProfileAndSettingsBase: React.FC<{
  renderTrigger: (state: ProfileAndSettingsState) => React.ReactNode
  renderContent: (state: ProfileAndSettingsState) => React.ReactNode
}> = ({ renderContent, renderTrigger }) => {
  const state = useProfileAndSettingsState()

  return (
    <DropdownMenu.Root
      open={state.isModalOpen}
      onOpenChange={state.setIsModalOpen}>
      {renderTrigger(state)}
      {renderContent(state)}
    </DropdownMenu.Root>
  )
}
